export default "__VITE_ASSET__DgKHFycn__"